exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.singleMap[data-v-2391eb18] {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n.map-container[data-v-2391eb18] {\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n    position: relative;\n    width: 100%;\n    height: 100%;\n#basemap-selector[data-v-2391eb18] {\n        position: absolute;\n        right: 8px;\n        top: 8px;\n        z-index: 1;\n}\n}\n", ""]);

// exports
